import { render, staticRenderFns } from "./UpdateTask.vue?vue&type=template&id=74a9da43"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"
import style0 from "./UpdateTask.vue?vue&type=style&index=0&id=74a9da43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports